import React, { useEffect, useRef } from "react";
import useHealthProfile from "hooks/useHealthProfile";
import { useHistory, useParams } from "react-router-dom";
import { Form, Formik } from "formik";
import MedicalAssistant from "components/MedicalAssistant/MedicalAssistant";
import Spacer from "components/Spacer/Spacer";
import HealthProfileQuestion from "../../HealthProfileQuestion";
import HealthProfileRadio from "../../HealthProfileRadio";
import Input from "components/inputs/Input";
import CSSLoader from "components/cssLoader/CSSLoader";
import { HealthProfileExerciseValidationSchema } from "helpers/validationSchema";
import FormikErrorFocus from "formik-error-focus";
import SimpleHeader from "components/header/SimpleHeader";

const YESNO = ["Yes", "No"];
const FREQUENCY = ["Day", "Week", "Month", "Year"];

function Exercise() {
  const formRef = useRef();
  const history = useHistory();
  const { health_id } = useParams();

  const {
    healthPayload,
    postHealthProfile,
    postingHealthProfile,
  } = useHealthProfile();

  useEffect(() => {
    if (
      healthPayload?.health_profile &&
      healthPayload?.health_profile?.physical_activity
    ) {
      formRef?.current?.setValues({
        exercise_regularly:
          healthPayload?.health_profile?.physical_activity?.regular_exercise ??
          "",
        type_of_execise:
          healthPayload?.health_profile?.physical_activity?.exercise_type ?? "",
        number_of_minutes:
          healthPayload?.health_profile?.physical_activity?.no_of_minutes ?? "",
        frequency:
          healthPayload?.health_profile?.physical_activity?.frequency ?? "",
      });
    }
  }, [healthPayload]);

  function completed() {
    history.goBack();
  }

  function onSave(values) {
    let payload = {
      physical_activity: {
        regular_exercise: values?.exercise_regularly,
        exercise_type: values?.type_of_execise,
        frequency: values?.frequency,
        no_of_minutes: values?.number_of_minutes,
      },
    };
    postHealthProfile({ healthId: health_id, payload, completed });
  }
  return (
    <div className="h-screen bg-veryLightBlue">
      <Formik
        innerRef={formRef}
        onSubmit={onSave}
        initialValues={{
          exercise_regularly: "",
          type_of_execise: "",
          number_of_minutes: "",
          frequency: "",
        }}
        validationSchema={HealthProfileExerciseValidationSchema}
      >
        {({ values, submitCount, errors, setFieldValue, setValues }) => (
          <Form className="h-full">
            <SimpleHeader
              showBackButton
              title="Exercise"
              rightActionView={
                <button
                  disabled={postingHealthProfile}
                  type={"submit"}
                  className="text-2xl font-bold text-orange"
                >
                  {postingHealthProfile ? (
                    <CSSLoader className="w-8 h-8" color="orange" />
                  ) : (
                    "Save"
                  )}
                </button>
              }
            />
            <div className="p-12 overflow-y-auto bg-white h-eliminateHeaderWithBottomTab md:h-eliminateHeader">
              <MedicalAssistant
                content={
                  <p>Please tell us about your physical activity level.</p>
                }
              />
              <Spacer height={26} />
              <HealthProfileQuestion text={"Do you exercise regularly?"} />
              <div className={`flex items-center mt-8 flex-wrap`}>
                {YESNO?.map((option, idx) => {
                  return (
                    <div className="flex flex-1 mb-8 mr-6" key={idx}>
                      <HealthProfileRadio
                        text={option}
                        selected={values?.exercise_regularly === option}
                        onClick={() => {
                          if (option === "No") {
                            setValues({
                              exercise_regularly: option,
                              type_of_execise: "",
                              number_of_minutes: "",
                              frequency: "",
                            });
                          } else {
                            setFieldValue("exercise_regularly", option);
                          }
                        }}
                      />
                    </div>
                  );
                })}
              </div>
              {submitCount && errors?.exercise_regularly ? (
                <p className="mt-4 text-base font-bold text-red">
                  {errors?.exercise_regularly}
                </p>
              ) : null}
              {values?.exercise_regularly === "Yes" ? (
                <>
                  <Spacer height={26} />
                  <Input
                    labelstyles={{
                      fontWeight: "500",
                      textOpacity: 1,
                      color: "rgba(16, 19, 71, 1)",
                    }}
                    label="What type of exercise do you do?"
                    id="type_of_execise"
                    name="type_of_execise"
                  />
                  <Spacer height={26} />
                  <Input
                    labelstyles={{
                      fontWeight: "500",
                      textOpacity: 1,
                      color: "rgba(16, 19, 71, 1)",
                    }}
                    type="number"
                    label="Number of minutes?"
                    id="number_of_minutes"
                    name="number_of_minutes"
                    min="1"
                  />
                  <Spacer height={26} />
                  <HealthProfileQuestion text={"Frequency (per)"} />
                  <div className={`flex items-center mt-8 flex-wrap`}>
                    {FREQUENCY?.map((frequency, idx) => {
                      return (
                        <div className="flex flex-1 mb-8 mr-6" key={idx}>
                          <HealthProfileRadio
                            text={frequency}
                            selected={values?.frequency === frequency}
                            onClick={() =>
                              setFieldValue("frequency", frequency)
                            }
                          />
                        </div>
                      );
                    })}
                  </div>
                  {submitCount && errors?.frequency ? (
                    <p className="mt-4 text-base font-bold text-red">
                      {errors?.frequency}
                    </p>
                  ) : null}
                </>
              ) : null}
            </div>
            <FormikErrorFocus align={"bottom"} ease={"linear"} duration={500} />
          </Form>
        )}
      </Formik>
    </div>
  );
}

export default Exercise;
